import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "scoreBoard" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("li", null, "SCORE | PLAYTIME | HITS/SHOTS", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }, "X"),
    _createElementVNode("ul", null, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoreStore.getScore, (score) => {
        return (_openBlock(), _createElementBlock("li", { key: score }, [
          (score.result)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(score.result) + " | " + _toDisplayString(_ctx.formatTime(score.playtime)) + " | " + _toDisplayString(score.totalHits) + "/" + _toDisplayString(score.totalShots), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_ctx.scoreStore.getScore.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "NO SCORES YET"))
      : _createCommentVNode("", true)
  ]))
}